import React from 'react'
import Dotdotdot from 'react-dotdotdot'
import InputNumber from 'antd/lib/input-number'
import Input from 'antd/lib/input'
import Button from 'antd/lib/button'

class ResultItem extends React.Component {
  renderIcons = () => {
    const icons = []
    const property = this.props.property

    
    let atts;
    let total_car_park = 0;
    if (property['feed_source'] !== 'palace_api'){
       // this is sales property
       atts = ['bedroom', 'bathroom']

       //get total car park count
       total_car_park = Number(property['garage_count']) + Number(property['carport_count']) + Number(property['off_street_parking'])
    

    }else{
       // this is rental property
       atts = ['bedroom', 'bathroom', 'carpark']
    }
    
    atts.forEach(icon => {
      const field = `${icon}_count`
      if (property[field] && property[field] > 0) icons.push(
        <span className="icon__count" key={icon}>
          <span className={`icon-${icon}`}></span>
          <span className="icon__count-badge">{property[field]}</span>
        </span>
      )

      if(icon == 'off_street_parking'){
        if(property['off_street_parking'] > 0) icons.push(
          <span className="icon__count" key={icon}>
            <span className={`icon-offstreetparking`}></span>
            <span className="icon__count-badge">{property['off_street_parking']}</span>
          </span>
        )
      }
    })

    // Add combined total car park icon only once
    if (total_car_park > 0) {
      icons.push(
        <span className="icon__count" key="carpark">
          <span className="icon-carpark"></span>
          <span className="icon__count-badge">{total_car_park}</span>
        </span>
      );
    }


    if (property['fully_furnished']) {
      icons.push(
        <span className="icon--text-beside">
          <span className="icon-furnished" />
          <span className="icon__text">Fully<br />Furnished</span>
        </span>
      )
    }

    return icons
  }

  renderRentedBanner = () => {
    if (this.props.property.property_status !== 'leased') return
    return <div className="result-item__banner property__banner"><span>{this.props.strings.rented}</span></div>/* Add: if this.props.property.property_status === 'sold' .strings.sold */
  }

  renderSoldBanner = () => {
    // if (this.props.property.property_status !== 'sold') return
    // return <div className="result-item__banner property__banner property__banner--sold"><span>{this.props.strings.sold}</span></div>
    if (this.props.property.property_status_text !== 'Sold') return
    return <div className="result-item__banner property__banner property__banner--sold"><span>{this.props.strings.sold}</span></div>
  }

  renderOpenHomeBanner = () => {
    if (!this.props.property.ire_viewing_times.length) return
    return <div className="result-item__banner property__banner property__banner--right result-item__banner--right"><span>{this.props.strings.open_home}</span></div>
  }

  renderUnderOfferBanner = () => {
    if (this.props.property.property_status_text !== 'Under Offer') return
    return <div className="result-item__banner property__banner property__banner--right result-item__banner--right"><span>{this.props.strings.under_offer}</span></div>
  }

  renderRentFrequency = () => {
    let freq = 'p/w'
    switch (this.props.property.rent_frequency) {
      case 'per_annum':
        freq = 'p/a'
        break
      case 'per_night':
        freq = 'p/n'
        break
      default:
        freq = 'p/w'
        break
    }
    return freq
  }

  renderEnquiries = () => {
    return Object.keys(this.props.property.enquiries).map(enquiryCatId => {
      return (
        <span className="result-item__enquiry" key={enquiryCatId}>
          {this.props.property.enquiries[enquiryCatId].label}
          <span className="result-item__enquiry-count">{this.props.property.enquiries[enquiryCatId].enquiries.length}</span>
        </span>
      )
    })
  }

  convertReadableTime = (timeStr) =>{
    
    const dateObj = new Date(timeStr);

    const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const dayOfWeek = daysOfWeek[dateObj.getDay()];

    const dayOfMonth = dateObj.getDate();

    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const month = months[dateObj.getMonth()];

    let hours = dateObj.getHours();
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    const minutes = dateObj.getMinutes();
    const formattedTime = `${dayOfWeek} ${dayOfMonth} ${month} ${hours}:${minutes < 10 ? '0' + minutes : minutes} ${ampm}`;
    return formattedTime;

  }

  renderPrice() {
    let { isSalesType } = false;
    isSalesType = this.props.property.listing_type === 'sales' ? true : false

    if (isSalesType){
      let selling_event = '';
      if(this.props.property.selling_event){
        selling_event = this.convertReadableTime(this.props.property.selling_event.at);
      }

      return (
        <div className="result-item__price">
          <strong>{this.props.property.sale_type}</strong>
          <div className="subtext">
            {this.props.property.sale_type_subtext}
            {selling_event}
          </div>
        </div>
      )
    }

    if (this.props.fieldsToRemove.indexOf('price') > -1) return null
    if(this.props.property.listing_type === 'offmarket' && this.props.property.page_template === 'sales') {
      return (
        <div className="result-item__price">
          <span><strong>{this.props.property.display_price}</strong></span>
          <span>{this.props.property.sale_type}</span>
        </div>
      )
    }

    if (this.props.property.sales_options === "negotiation") {
      return (
        <div className="result-item__price">
          <span><strong>By Negotiation</strong></span>
          <span>{this.props.property.date_available_short}</span>
        </div>
      );
    }

    return (
      <div className="result-item__price">
        <span><strong>{this.props.property.display_price}</strong> {this.renderRentFrequency()}</span>
        <span>{this.props.property.date_available_short}</span>
      </div>
    );
  }

  onPriceChange = (value) => {
    this.props.onUpdate(this.props.property.post_id, { price: value })
  }

  onSubtitleChange = (e) => {
    this.props.onUpdate(this.props.property.post_id, { subtitle: e.target.value })
  }

  renderSubtitleInput() {
    let newsubTitle = this.props.property.display_subtitle
    if (this.props.property.listing_type !== 'residential') { newsubTitle = this.props.property.suburb_string }

    if (!this.props.editing || !this.props.showSubTitleEdit) return (
      <Dotdotdot clamp={1} className="h5">
        {newsubTitle}
      </Dotdotdot>
    )
    return (
      <div className="result-item__subtitle-edit">
        <Input
          defaultValue={this.props.property.display_subtitle}
          name={`subtitle-edit-${this.props.property.post_id}`}
          onChange={this.onSubtitleChange}
        />
      </div>
    )
  }

  maybeRenderPrice() {
    if (!this.props.editing || !this.props.showPriceEdit) return this.renderPrice()
    return (
      <div className="result-item__price-edit">
        <InputNumber
          defaultValue={this.props.property.rent_per_week}
          formatter={value => `$ ${value}`}
          parser={value => value.replace(/\$\s?|(,*)/g, '')}
          addonBefore="$"
          name={`price-edit-${this.props.property.post_id}`}
          min={0}
          onChange={this.onPriceChange}
        />
        <div className="result-item__origina-price">Base price: {this.props.property.display_price_original}</div>
      </div>
    )
  }

  maybeRenderRemove(pendingRemoval = false) {
    if (!this.props.editing || !this.props.showCatEdit) return null

    // if it's already marked for removal, switch the button
    if (pendingRemoval) return <Button shape="circle" icon="delete" type="danger" onClick={this.onRestore} className="result-item__mark-remove" />
    return <Button type="danger" shape="circle" icon="delete" ghost onClick={this.onRemove} className="result-item__mark-remove" />
  }

  renderVirtualTour() {
    if (!this.props.property.virtual_tour_link) return null
    return (
      <span className="spin-360__wrap">
        <svg xmlns="http://www.w3.org/2000/svg" width="73.215" height="69.232" viewBox="0 0 73.215 69.232" className="spin-360"><g fill="#004948"><path className="spin-360__arrows" d="M11.971 11.53a1 1 0 0 0 1.4-.015c12.753-12.758 33.434-12.762 46.192-.009a32.665 32.665 0 0 1 7.604 34.264l-3.801-1.37a.981.981 0 0 0-1.26 1.248l2.561 7.32a.98.98 0 0 0 1.433.516l6.639-4.005a.983.983 0 0 0-.174-1.765l-3.553-1.279c6.535-17.971-2.734-37.837-20.705-44.372a34.625 34.625 0 0 0-36.342 8.082l-.01.009a.966.966 0 0 0 .005 1.365l.011.011zm54.151 39.648l-1.479-4.23 5.318 1.916-3.839 2.314zM61.02 57.662a.982.982 0 0 0-1.389-.002v.002l-.057.055c-12.762 12.758-33.45 12.755-46.208-.008a32.675 32.675 0 0 1-7.33-34.977l3.648 1.473a.983.983 0 0 0 1.305-1.2l-2.283-7.411a.981.981 0 0 0-1.414-.569L.507 18.777a.981.981 0 0 0 .107 1.771l3.6 1.451C-2.752 39.814 6.044 59.905 23.86 66.87a34.639 34.639 0 0 0 37.105-7.764l.055-.056a.982.982 0 0 0 0-1.388zM7.186 17.327l1.32 4.282-5.242-2.113 3.922-2.169z" /></g><g fill="#004948"><path className="spin-360__text" d="M25.902 35.125a3.915 3.915 0 0 0 1.91-3.363c0-2.813-2.065-4.562-5.389-4.562a5.31 5.31 0 0 0-5.564 4.431.893.893 0 0 0 .614 1.018l.464.147c.238.07.495.041.712-.081a.913.913 0 0 0 .427-.58 3.1 3.1 0 0 1 3.348-2.7c1.857 0 2.88.86 2.88 2.42 0 1.454-.984 2.19-2.926 2.19h-1.1a.9.9 0 0 0-.895.899v.51c0 .495.399.896.895.899h1.1c1.945 0 3.2.887 3.2 2.257 0 1.56-1.153 2.491-3.087 2.491a3.5 3.5 0 0 1-3.734-2.854.9.9 0 0 0-1.218-.628l-.562.232a.889.889 0 0 0-.539.976c.472 2.777 2.782 4.5 6.031 4.5 3.308 0 5.619-1.893 5.619-4.601a3.962 3.962 0 0 0-2.186-3.601zM35.95 32.545a5.358 5.358 0 0 0-3.977 1.6 6.445 6.445 0 0 1 1.521-3.663 3.529 3.529 0 0 1 2.639-1.069 3.073 3.073 0 0 1 3.009 2.072c.09.23.27.414.5.508.23.09.488.082.715-.022l.506-.238a.897.897 0 0 0 .465-1.096 5.15 5.15 0 0 0-5.201-3.434c-4.077 0-6.609 3.221-6.609 8.407 0 4.829 2.367 7.712 6.333 7.712 3.417 0 5.711-2.185 5.711-5.434.007-3.147-2.302-5.343-5.612-5.343zm3.131 5.388a2.977 2.977 0 0 1-3.223 3.133c-2.085 0-3.432-1.229-3.432-3.133 0-1.92 1.248-3.065 3.339-3.065 2.048 0 3.318 1.175 3.318 3.065h-.002zM49.522 27.2c-4.068 0-6.4 2.937-6.4 8.06s2.334 8.06 6.4 8.06 6.4-2.938 6.4-8.06-2.332-8.06-6.4-8.06zm0 13.89c-.945 0-3.824 0-3.824-5.83s2.879-5.828 3.824-5.828c.947 0 3.824 0 3.824 5.828s-2.879 5.835-3.824 5.835v-.005zM57.672 21.095a3.667 3.667 0 0 0-3.666 3.663 3.663 3.663 0 1 0 7.328.002v-.001a3.667 3.667 0 0 0-3.662-3.664zm0 5.268a1.601 1.601 0 1 1 1.6-1.601 1.6 1.6 0 0 1-1.596 1.604h-.004v-.003z" /></g></svg>
      </span>
    )
  }

  onRemove = (e) => {
    e.preventDefault()
    this.props.onRemove(this.props.property.post_id)
    e.target.blur()
  }

  onRestore = (e) => {
    e.preventDefault()
    this.props.onRemoveRestore(this.props.property.post_id)
    e.target.blur()
  }

  maybeTitle() {
    if (this.props.property.listing_type !== 'sales') return (this.props.property.address)
    return (
      this.props.property.address
    )/* if sales show address */
  }

  render() {
    const { property } = this.props
    let classNames = 'result-item'
    if (this.props.supportsMixBlendMode) classNames += ' mix-overlay'
    if (this.props.swiperItem) classNames += ' swiper-slide'
    classNames += ' ' + property.listing_type + ' property-post-id-' + property.post_id

    let { isSalesType } = false;
    isSalesType = property.listing_type !== 'residential' ? true : false
    let AgentImage;

    // if (isSalesType) {
    //   AgentImage = <div className={`result-item__image agent`} style={{backgroundImage: property.images[0] ? this.props.property.agent_image : ''}}><div className="result-item__image-overlay"></div></div>;
    // } else {
    //   AgentImage = <span></span>;
    // }

    AgentImage = <div className={`result-item__image agent`} style={{ backgroundImage: property.images[0] ? this.props.property.agent_image : '' }}><div className="result-item__image-overlay"></div></div>;

    const pendingRemoval = this.props.propertiesToRemove && this.props.propertiesToRemove.indexOf(this.props.property.post_id) > -1
    if (pendingRemoval) classNames += ' result-item--pending-removal'

    // if we are editing we don't want to have a clickable wrapper
    const ResultTag = this.props.editing ? 'div' : 'a'
    return (
      <div className={classNames}>
        <ResultTag href={property.permalink}>
          {this.maybeRenderRemove(pendingRemoval)}
          <div className="result-item__image" style={{ backgroundImage: property.images[0] ? `url(${property.images[0].url})` : '' }}>
            <div className="result-item__image-overlay"></div>
            {this.renderUnderOfferBanner()}
            {this.renderOpenHomeBanner()}
          </div>
          {this.renderRentedBanner()}
          {this.renderSoldBanner()}
          <div className="result-item__content">
            <div className="result-item__title">
              <Dotdotdot clamp={2}>
                {this.maybeTitle()}
              </Dotdotdot>
              <div className="result-item__location">
                <span className="result-item__location-text">{property.suburb_string}</span>
              </div>
            </div>
            <div className="result-item__subtitle">
              {this.renderSubtitleInput()}
            </div>
            <div className="result-item__enquiries">
              {this.renderEnquiries()}
            </div>
            <div className="result-item__icons">
              <div className="left">{this.renderIcons()}</div>
              {this.renderVirtualTour()}
            </div>
            <div className="result-item__available">
            </div>
            {this.maybeRenderPrice()}
          </div>
          {AgentImage}
        </ResultTag>
      </div>
    )
  }
}

export default ResultItem


// WEBPACK FOOTER //
// ./src/components/results/ResultItem.js